import { Pipe, inject, PipeTransform } from "@angular/core";
import { AsPipeBase } from "../bases/as-pipe-base";
import { AppDefinitions } from "../app-definitions.service";

@Pipe({
    name: "asTrc2",
    standalone: false
})
export class AsTrc2Pipe extends AsPipeBase implements PipeTransform {
    constructor() {
        const _appDefinitions = inject(AppDefinitions);

        super(_appDefinitions, "trc2");
    }
}
